/**
 * Map of width presets to CSS classes for Popover
 */
export const POPOVER_WIDTH_MAP = {
  auto: '',
  sm: 'w-[320px]',
  md: 'w-[364px]',
  lg: 'w-[380px]',
  xl: 'w-[460px]',
  trigger: 'w-[var(--radix-popover-trigger-width)]',
} as const
